import React from 'react'
import Icon from '../../icon'
import classNames from 'classnames'

export interface DismissibleProps {
  text: string | undefined
  onClick: () => void
  className?: string
}

const TagDismissible = ({ text, onClick, className }: DismissibleProps) => {
  return (
    <button className={classNames('c-pill', className)} onClick={onClick}>
      <span className="u-mr-16">{text}</span>
      <Icon className="i-14" name="close" />
    </button>
  )
}

export default TagDismissible
